import Header from '@/components/layout/Header';
import GameCard from '@/components/layout/GameCard';
import { games } from '@/data/games';

/** Startseite — Game-Auswahl-Grid */
export default function GameSelectPage() {
  return (
    <div>
      <Header />
      <main className="mx-auto max-w-6xl px-6 py-8" data-testid="game-select">
        <p className="mb-8 text-center text-lg text-gray-600 dark:text-gray-300">
          Wähle ein Spiel aus und leg los! 🚀
        </p>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {games.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      </main>
    </div>
  );
}
